<div class="modal-header">
	<h4 class="modal-title">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ORDERSTATUSMODAL.TITLE' | localize }}</h4>
	<button type="button" class="close" aria-label="Close" (click)="modalClose()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<table class="table" *ngIf="!approvalUsersHasPersonInCharge">
		<thead>
			<tr>
				<th scope="col">#</th>
				<th scope="col">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ORDERSTATUSMODAL.COLUMN.NAME' | localize }}</th>
				<th scope="col">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ORDERSTATUSMODAL.COLUMN.STATUS' | localize }}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let approveUser of approvalUsers; let i = index">
				<th scope="row">{{i + 1}}</th>
				<td>{{approveUser.userName}}</td>
				<td>
					<!--KİŞİNİN ONAYCILARININ HANGİ AŞAMADA OLDUĞUNU VE KİMİN ONAYLADIĞINI GÖRÜYORUZ-->
					<!--<span [ngSwitch]="approveUser.approvalStatusType">
		<span *ngSwitchCase="1">ONAYLANDI</span>
		<span *ngSwitchCase="2">BEKLEMEDE</span>
		<span *ngSwitchCase="3">REDDETTİ</span>
			</span>-->
					{{approveUser.approvalStatusText}}
					<span class="la la-info-circle text-success productPiece" placement="top" ngbTooltip="{{approveUser.approvalStatusDescText}}" ngbTooltipClass="kt-tooltip">

					</span>
				</td>
			</tr>

		</tbody>
	</table>

	<div *ngIf="approvalUsersHasPersonInCharge">
		<h1 class="text-center">
			<span class="kt-widget20__number kt-font-brand">{{approvalUsers.length}}</span>
		</h1>

		
		<h4 class="text-center">
			{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ORDERSTATUSMODAL.PERSONINCHARGESTATUS' | localize }}
		</h4>

	</div>

</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="modalClose()"> {{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ORDERSTATUSMODAL.BUTTONS.CLOSE' | localize }}</button>
</div>

